import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import _ from 'lodash'
// UTILS
import { Utils } from 'utils/Utils'
import { currentVehicleType as currentVehicleTypeUtils, miniMumMinutes } from 'utils/new_booking/common'
import I18n from 'i18n/i18n'
// ACTIONS
import * as assignDriverActionCreators from 'store/actions/new_booking/assignDriverActionCreators'

// COMPONENTS
import BookingCalendar from '../../common/BookingCalendar'
import UnavailableAssignDriverPopupEye from '../../common/popup/driver_preferences/UnavailableAssignDriverPopupEye'
import AssignableDriver from '../../common/driver_preference/AssignableDriver'
// CONSTANTS
import {
  ICON_AVATAR_FLEET_PARTNER_ASSIGN_DRIVER,
  QUESTION_ICON_GRAY,
} from 'constants/imageConstants'
import { bindActionCreators } from 'redux'
// API
// ASSETS

const mapStateToProps = state => ({
  currentVehicleType: currentVehicleTypeUtils(state),
  tmpSelectedDateAssignDriver: state.tmpSelectedDateAssignDriver,
  tmpSelectedTimeAssignDriver: state.tmpSelectedTimeAssignDriver,
  assignedPickupTime: state.assignedPickupTime,
  estimatedWorkingTime: state.estimatedWorkingTime,
  timeType: state.timeType,
  selectedAmountFullDay: state.extraServices.fullDayPricing.selected_amount,
})

function mapDispatchToProps(dispatch) {
  return {
    assignDriverActions: bindActionCreators(assignDriverActionCreators, dispatch),
  }
}

class UnavailableDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      availableTimeSlots: [],
    }
    this.closeCalendar = this.closeCalendar.bind(this)
    this.handleSelectTimeSlot = this.handleSelectTimeSlot.bind(this)
  }

  componentWillMount() {
    this.setTimeSlots()
  }

  componentDidMount() {
    const {
      countryCode,
      tmpSelectedDateAssignDriver,
      assignDriverActions,
      assignedPickupTime,
    } = this.props
    const { availableTimeSlots } = this.state
    const options = {
      closetElement: this.driverSlider,
      contentElement: this.driverSliderContent,
      arrowLeft: this.driverSliderArrowLeft,
      arrowRight: this.driverSliderArrowRight,
    }
    if (!_.isEmpty(tmpSelectedDateAssignDriver)) {
      const preferTimeSlot = Utils.getPreferTimeSlot(availableTimeSlots, tmpSelectedDateAssignDriver, countryCode)
      if (_.includes(availableTimeSlots, preferTimeSlot)) {
        Utils.slideToTimeSlot(options, preferTimeSlot)
      }
    } else if (!_.isEmpty(assignedPickupTime) && (_.isEmpty(tmpSelectedDateAssignDriver)
      || assignedPickupTime === tmpSelectedDateAssignDriver)) {
      const selectedTime = moment(assignedPickupTime).format('HH:mm')
      Utils.slideToTimeSlot(options, selectedTime)
      assignDriverActions.changeTmpSelectedDateAssignDriver(assignedPickupTime)
      assignDriverActions.changeTmpSelectedTimeAssignDriver(selectedTime)
    }
    Utils.initDriverSlider(options)
  }

  componentDidUpdate(prevProps) {
    const { tmpSelectedDateAssignDriver: prevDateAssigned } = prevProps
    const { tmpSelectedDateAssignDriver, countryCode } = this.props
    const { availableTimeSlots } = this.state

    if (prevDateAssigned !== tmpSelectedDateAssignDriver) {
      const options = {
        closetElement: this.driverSlider,
        contentElement: this.driverSliderContent,
        arrowLeft: this.driverSliderArrowLeft,
        arrowRight: this.driverSliderArrowRight,
      }

      if (!_.isEmpty(tmpSelectedDateAssignDriver)) {
        const preferTimeSlot = Utils.getPreferTimeSlot(availableTimeSlots, tmpSelectedDateAssignDriver, countryCode)
        if (_.includes(availableTimeSlots, preferTimeSlot)) {
          Utils.slideToTimeSlot(options, preferTimeSlot)
        }
      }
      Utils.initDriverSlider(options)
    }
  }

  setTimeSlots(selectedTime = null, cb = () => { }) {
    const {
      blockedTimeInfos,
      estimatedWorkingTime,
      selectedAmountFullDay,
      tmpSelectedDateAssignDriver,
      timeType,
      currentVehicleType,
    } = this.props
    let currentDate = selectedTime
    if (_.isEmpty(selectedTime)) {
      currentDate = tmpSelectedDateAssignDriver
    }
    const minutePickup = miniMumMinutes(currentVehicleType, timeType)
    const availableTimes = Utils.getAvailableTimeSlots(blockedTimeInfos, currentDate, minutePickup,
      estimatedWorkingTime, selectedAmountFullDay)
    this.setState({
      availableTimeSlots: availableTimes
    }, () => {
      cb()
    })
  }

  closeCalendar(cancel, selectedDateTime) {
    const { assignDriverActions } = this.props
    this.setState({
      showCalendarPickup: false,
    })
    if (!cancel) {
      $(this.driverSliderContent).children('span').removeClass('Dark-Green-bg cur-default').addClass('White-bg default-color cur-pointer')

      this.setTimeSlots(selectedDateTime, () => {
        assignDriverActions.changeTmpSelectedDateAssignDriver(selectedDateTime)
        assignDriverActions.changeTmpSelectedTimeAssignDriver('')
      })
    }
  }

  showCalendarDriver() {
    this.setState({
      showCalendarPickup: true,
    })
  }

  handleSelectTimeSlot(event, time) {
    const { closePopup } = this.props
    $(this.driverSliderContent).children('span').removeClass('Dark-Green-bg cur-default').addClass('White-bg default-color cur-pointer')
    $('.Popover-Item-Driver-Item.Modal-Driver-Change-Date-Time').removeClass('error')
    $('.Popover-Item-Driver-Item.Modal-Driver-Change-Date-Time .Item-Driver-Show').addClass('hidden')
    const { assignDriverActions } = this.props

    Promise.resolve(
      assignDriverActions.changeTmpSelectedTimeAssignDriver(time)
    ).then(() => {
      closePopup(true)
    })
  }

  render() {
    const {
      countryCode,
      driver,
      dataUnavailablePopupEye,
      tmpSelectedDateAssignDriver,
      maxPickupTimeDays,
      assignedPickupTime,
      tmpSelectedTimeAssignDriver
    } = this.props
    const {
      showCalendarPickup,
      availableTimeSlots,
    } = this.state
    const driverAvatar = driver.fleet_partner_id ? ICON_AVATAR_FLEET_PARTNER_ASSIGN_DRIVER : driver.driver_image_url
    const driverName = driver.fleet_partner_name || Utils.driverFirstName(driver.name)
    const currentVehicle = driver.current_vehicle
    const isSameDay = moment(tmpSelectedDateAssignDriver).isSame(assignedPickupTime, 'day')
    const pickupTime = tmpSelectedTimeAssignDriver && isSameDay ? moment(assignedPickupTime).format('H:mm') : ''
    let vehicleTypeName = ''

    if (!!currentVehicle && !!currentVehicle.vehicle_type_name) {
      vehicleTypeName = currentVehicle.vehicle_type_name
    }

    let driverPlateNumber = I18n.t('webapp.new_booking.step_2.assign_driver.fleet_plate_number')

    if (!!currentVehicle && !!currentVehicle.vehicle_attributes && _.isNull(driver.fleet_partner_id)) {
      driverPlateNumber = currentVehicle.vehicle_attributes.plate_number
    }

    return (
      <div
        className="Modal-Driver-Change-Date-Time pt10 pb10 unvailable-driver"
      >
        <AssignableDriver
          noClickHandler
          driverInfos={{
            avatar: {
              url: driverAvatar,
              size: ''
            },
            name: driverName,
            specialClass: 'Black-text',
            vehicleTypeName,
            driverPlateNumber
          }}
          isFleet={driver.fleet_partner_id}
          extraInfos={() => (
            <div className="flex-center invalid-driver-text">
              {I18n.t('label.preference_driver.schedule_conflict')}
            </div>
          )
          }
        />
        <div className="Popover-Item-Driver-Item-Middle mar20 mt10">
          <div className="select-available-text">
            {I18n.t('label.preference_driver.select_available_pickup_slot')}
            <UnavailableAssignDriverPopupEye
              dataUnavailablePopupEye={dataUnavailablePopupEye}
              icon={QUESTION_ICON_GRAY}
            />
          </div>
          <div
            className="Radius-default White-bg h38px relative flex flex-center-algin cur-pointer pickup-datetime"
            onClick={() => this.showCalendarDriver()}
          >
            <span className="default-font default-color flex-index ml10">
              {Utils.formatAssignDriverDate(moment(tmpSelectedDateAssignDriver), true)}
            </span>
            <i className="material-icons Icon large-icon mr10 Green-text">
              keyboard_arrow_down
            </i>
          </div>
        </div>
        {showCalendarPickup && (
          <BookingCalendar
            isShowOkBtn
            isShowCancelBtn
            selectedDateTime={tmpSelectedDateAssignDriver}
            minMinutes={0}
            closePicker={this.closeCalendar}
            maximumPickupDays={maxPickupTimeDays}
            modalCssClassName="PickupTime-Modal-Driver"
            countryCode={countryCode}
            visibleTimer={false}
          />
        )}
        {_.isEmpty(availableTimeSlots) ? (
          <p className="center default-font unvailable-desc">
            {`${I18n.t('label.preference_driver.driver_not_available')}`}
          </p>
        )
          : (
            <div className="Popover-Item-Driver-Item-Bottom">
              <div className="Driver-Item-Sliders flex">
                <div
                  ref={(ref) => {
                    this.driverSliderArrowLeft = ref
                  }}
                  className="Driver-Item-Arrow Left flex flex-center-algin"
                >
                  <i className="material-icons Icon xxs-large-icon cur-pointer">
                    keyboard_arrow_left
                  </i>
                </div>
                <div
                  ref={(ref) => {
                    this.driverSlider = ref
                  }}
                  className="Driver-Item-Slider o-hidden flex flex-index"
                >
                  <div
                    ref={(ref) => {
                      this.driverSliderContent = ref
                    }}
                    className="flex"
                  >
                    {availableTimeSlots.map(slider => (
                      <span
                        key={`slider-${slider}`}
                        onClick={e => this.handleSelectTimeSlot(e, slider)}
                        className={`slot-time default-font mr15 pt10 pr15 pb10 pl15 Box-Sizing Border-Box ${slider === pickupTime
                          ? 'selected White-text cur-default' : 'White-bg default-color cur-pointer'}`}
                      >
                        {slider}
                      </span>
                    ))}
                  </div>
                </div>
                <div
                  ref={(ref) => {
                    this.driverSliderArrowRight = ref
                  }}
                  className="Driver-Item-Arrow Right flex flex-center-algin"
                >
                  <i className="material-icons Icon xxs-large-icon cur-pointer">
                    keyboard_arrow_right
                  </i>
                </div>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}

UnavailableDriver.propTypes = {
  assignDriverActions: PropTypes.shape({}).isRequired,
  driver: PropTypes.shape({}).isRequired,
  currentVehicleType: PropTypes.shape({}).isRequired,
  dataUnavailablePopupEye: PropTypes.shape({}).isRequired,
  countryCode: PropTypes.string.isRequired,
  selectedAmountFullDay: PropTypes.number.isRequired,
  maxPickupTimeDays: PropTypes.number.isRequired,
  blockedTimeInfos: PropTypes.shape({}),
  estimatedWorkingTime: PropTypes.number,
  assignedPickupTime: PropTypes.string,
  tmpSelectedDateAssignDriver: PropTypes.string,
  tmpSelectedTimeAssignDriver: PropTypes.string,
  timeType: PropTypes.string,
  closePopup: PropTypes.func
}

UnavailableDriver.defaultProps = {
  assignedPickupTime: undefined,
  tmpSelectedDateAssignDriver: undefined,
  tmpSelectedTimeAssignDriver: undefined,
  timeType: undefined,
  estimatedWorkingTime: undefined,
  blockedTimeInfos: {},
  closePopup: () => { }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnavailableDriver)
